// See useIsMounted.spec.md for UIM-FR-001

import { useCallback, useEffect, useRef } from 'react'

// UIM-FR-001: Returns a stable function that tells whether the component is still mounted, so an
// async callback can skip its state updates once the component is gone
export default function useIsMounted(): () => boolean {
  const mounted = useRef(false)
  useEffect(() => {
    mounted.current = true
    return () => {
      mounted.current = false
    }
  }, [])
  return useCallback(() => mounted.current, [])
}
